import api from './api';
import { toSaveDate, toSaveEndDate } from '../../utilis/date-formats';
const API_PREFIX = "api/overall";

const getValidations = async () => {
    const response = await api.get(`api/validation/all`);
    return response;
};

// const getCardPatientChartDataPost= async (body = null, { signal } = {}) => {
//     body = filterBodyDate(body);
//     const config = {
//         headers: { 'Content-Type': 'application/json' }, // Optional, specify headers if needed
//         signal, // Pass the AbortController's signal here
//     };
//     const response = await api.post(`${API_PREFIX}/card-patient-chart-data`, body, config);
//     return response;
// };

const getCardPatientChartData = async (body = null, { signal } = {}) => {
    const params = {
        facilityId: body.facilityId,
        facilityIds: body.facilityIds?.join(','),

        type: body.type,
        relation: body.relation,
        transferType: body.transferType,
        isSkipCustomCard: body.isSkipCustomCard,
        customCardType: body.customCardType,
    };

    if (!!body?.filter) {
        params.startDate = toSaveDate(body.filter.startDate);
        params.endDate = toSaveEndDate(body.filter.endDate);
        params.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    if (body?.cardFilter) {
        params.cardFilter = JSON.stringify({
            doctorData: body.cardFilter.doctorData?.map(d => d._id || d),
            floorsData: body.cardFilter.floorsData?.map(f => f._id || f),
            insuranceData: body.cardFilter.insuranceData?.map(i => i._id || i),
            ninetyDaysData: body.cardFilter.ninetyDaysData ?? [],
        });
    }

    return api.get(
        `${API_PREFIX}/card-patient-chart-data`,
        { params, signal }
    );
};

const getAllOverallCount = async (params, { signal } = {}) => {
    const apiParams = { ...params };
    apiParams.startDate = toSaveDate(params.startDate);
    apiParams.endDate = toSaveEndDate(params.endDate);

    const config = {
        params: apiParams,
        signal, // Pass the AbortController's signal here
    };

    const response = await api.get(`${API_PREFIX}/get-all-count`, config);
    return response;
};

export {
    getValidations,
    getCardPatientChartData,
    getAllOverallCount
};
